// extracted by mini-css-extract-plugin
module.exports = {"scriptEmbedWrapper":"contentBlockRenderer_scriptEmbedWrapper__1ZDT2"};